import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
const useOrderConfirmLabels = (order) => {
  const { getLabel, getFormattedLabel } = useIntl();
  return React.useMemo(
    () => ({
      title: getLabel("checkout.completed.title"),
      completed: getLabel("checkout.completed.message"),
      orderPending: {
        title: getFormattedLabel("checkout.completed.hero.alert.title", {
          labelData: {
            orderNumber: order?.orderNumber || ""
          }
        }),
        message: getLabel("checkout.pending.message")
      },
      orderPlaced: {
        title: getFormattedLabel("checkout.completed.hero.alert.title", {
          labelData: {
            orderNumber: order?.orderNumber || ""
          }
        }),
        message: getFormattedLabel("checkout.completed.hero.alert.message", {
          labelData: {
            customerEmail: order?.customerDetails?.email || ""
          }
        })
      },
      orderContainsSunglasses: getLabel("checkout.completed.cartContainsSunglasses"),
      orderContainsPrescriptionGlasses: getLabel(
        "checkout.completed.cartContainsPrescriptionGlasses"
      ),
      shipmentDetailsTitle: getLabel("checkout.completed.shipmentDetails.title"),
      yourDetails: getLabel("checkout.yourDetails"),
      orderDetailsHeader: getLabel("checkout.orders.header"),
      serviceStoreTitle: getLabel("checkout.serviceStore.title"),
      summary: {
        delivery: getLabel("checkout.summary.shipment.delivery"),
        deliveryExpress: getLabel("checkout.summary.shipment.deliveryExpress"),
        pickupStore: getLabel("checkout.summary.shipment.pickup"),
        pickupPoint: getLabel("checkout.summary.shipment.pickupPoint"),
        nearestPickup: getLabel("checkout.summary.shipment.nearestPickup"),
        deliveryPremium: getLabel("checkout.summary.shipment.deliveryPremium"),
        deliveryResponsible: getLabel("checkout.summary.shipment.deliveryResponsible")
      },
      error: {
        title: getLabel("checkout.errors.general.title"),
        message: getLabel("checkout.errors.general.message")
      }
    }),
    [getFormattedLabel, getLabel, order?.customerDetails?.email, order?.orderNumber]
  );
};
export {
  useOrderConfirmLabels
};
//# sourceMappingURL=use-order-confirm-labels.js.map
